import { useEffect, useRef, useCallback } from "react";
import Navbar from "./Navbar";
import "./RewardProof.css";
import BannerAds from "./BannerAds";

function RewardProof() {
  const canvasRef = useRef(null);
  const rootRef = useRef(null);
  const animRef = useRef(null);

  const COLORS = ["#fbbf24", "#f472b6", "#6332ff", "#00ffc8", "#a78bfa", "#fb923c"];

  const makeParticle = useCallback((W, H) => ({
    x: Math.random() * W,
    y: Math.random() * H,
    vx: (Math.random() - 0.5) * 0.4,
    vy: (Math.random() - 0.5) * 0.4,
    r: Math.random() * 1.8 + 0.4,
    color: COLORS[Math.floor(Math.random() * COLORS.length)],
    alpha: Math.random() * 0.6 + 0.2,
    pulse: Math.random() * Math.PI * 2,
  }), []);

  useEffect(() => {
    const canvas = canvasRef.current;
    const root = rootRef.current;
    if (!canvas || !root) return;
    const ctx = canvas.getContext("2d");
    let W = root.offsetWidth;
    let H = Math.max(root.offsetHeight, window.innerHeight);
    let particles = [];

    const resize = () => {
      W = root.offsetWidth;
      H = Math.max(root.offsetHeight, window.innerHeight);
      canvas.width = W;
      canvas.height = H;
    };
    resize();
    particles = Array.from({ length: 90 }, () => makeParticle(W, H));

    const draw = () => {
      ctx.clearRect(0, 0, W, H);
      particles.forEach((p) => {
        p.x += p.vx; p.y += p.vy; p.pulse += 0.018;
        if (p.x < 0) p.x = W; if (p.x > W) p.x = 0;
        if (p.y < 0) p.y = H; if (p.y > H) p.y = 0;
        const pa = p.alpha * (0.7 + 0.3 * Math.sin(p.pulse));
        ctx.beginPath();
        ctx.arc(p.x, p.y, p.r, 0, Math.PI * 2);
        ctx.fillStyle = p.color;
        ctx.globalAlpha = pa;
        ctx.fill();
      });
      ctx.globalAlpha = 1;
      for (let i = 0; i < particles.length; i++) {
        for (let j = i + 1; j < particles.length; j++) {
          const dx = particles[i].x - particles[j].x;
          const dy = particles[i].y - particles[j].y;
          const dist = Math.sqrt(dx * dx + dy * dy);
          if (dist < 100) {
            ctx.beginPath();
            ctx.moveTo(particles[i].x, particles[i].y);
            ctx.lineTo(particles[j].x, particles[j].y);
            ctx.strokeStyle = particles[i].color;
            ctx.lineWidth = 0.5;
            ctx.globalAlpha = (1 - dist / 100) * 0.12;
            ctx.stroke();
          }
        }
      }
      ctx.globalAlpha = 1;
      animRef.current = requestAnimationFrame(draw);
    };
    draw();

    const ro = new ResizeObserver(resize);
    ro.observe(root);
    window.addEventListener("resize", resize);
    return () => {
      cancelAnimationFrame(animRef.current);
      ro.disconnect();
      window.removeEventListener("resize", resize);
    };
  }, [makeParticle]);

  const proofData = [
    {
      id: 1,
      name: "Shiva",
      reward: "₹40",
      img: "/rewarde.jpeg",
      label: "Winner 1",
    },
  ];

  return (
    <div className="rp-root" ref={rootRef}>
      <canvas className="rp-canvas" ref={canvasRef} />
      <div className="rp-aurora" />

      <video autoPlay loop muted playsInline className="rp-bg-video">
        <source src="/radhakrishna.mp4" type="video/mp4" />
      </video>

      <Navbar />

      <div className="rp-container">

        {/* Header */}
        <div className="rp-header">
          <BannerAds/>
          <div className="rp-header-label">✦ verified payouts</div>
          <h1>This month's Reward Proof</h1>
          <p>transparent proof of rewards sent to montly winners</p>
        </div>

        {/* Cards */}
        <div className="rp-grid">
          {proofData.map((winner) => (
            <div className="rp-card" key={winner.id}>
              <div className="rp-scanline" />
              <div className="rp-card-glow" />

              <div className="rp-card-header">
                <div className="rp-winner-badge">🏆 {winner.label}</div>
                <div className="rp-reward-pill">{winner.reward}</div>
              </div>

              <div className="rp-divider" />

              <div className="rp-field-row">
                <span className="rp-field-label">Name</span>
                <span className="rp-field-value">{winner.name}</span>
              </div>
              <div className="rp-field-row">
                <span className="rp-field-label">Reward Amount</span>
                <span className="rp-field-value rp-reward-value">{winner.reward}</span>
              </div>

              <div className="rp-img-wrap">
                <img
                  src={winner.img}
                  alt="reward proof"
                  className="rp-img"
                />
                <div className="rp-img-caption">📸 Payment Screenshot</div>
              </div>
            </div>
          ))}
        </div>

        {/* Footer note */}
        <div className="rp-footer-note">
          <div className="rp-header-label" style={{ marginBottom: 10 }}>✦ transparency pledge</div>
          <p>We publish reward proofs every month. Winners are selected based on blog activity and contributions. All payments are processed via official channels only.</p>
        </div>

      </div>
    </div>
  );
}

export default RewardProof;